import { createContext, useContext } from 'react';
import type { PreviewVariablesContextType } from './PreviewVariablesContext.tsx';

export const PreviewContentVariablesContext = createContext<PreviewVariablesContextType | null>(null);

export const usePreviewContentVariables = () => {
  const variablesContext = useContext(PreviewContentVariablesContext);
  if (!variablesContext) {
    throw new Error('usePreviewContentVariables must be used within a PreviewContentVariablesProvider');
  }
  return variablesContext;
};
